"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformApiResponse = void 0;
class TransformApiResponse {
    transformAttributes({ attributes, transform, }) {
        if (!transform) {
            return undefined;
        }
        if (typeof transform === 'boolean') {
            return attributes;
        }
        const data = {};
        const keys = Object.keys(transform);
        for (const key of keys) {
            if (typeof transform[key] === 'boolean') {
                if (!transform[key]) {
                    continue;
                }
                data[key] = attributes[key];
            }
            else {
                data[key] = transform[key]?.(attributes[key]);
            }
        }
        return data;
    }
    getApiEntityRelation({ relation, relationships, included, }) {
        if (!relation || !included || !relationships) {
            return undefined;
        }
        const entityRelation = relationships[relation];
        if (!entityRelation) {
            return undefined;
        }
        if (Array.isArray(entityRelation.data)) {
            return entityRelation.data
                .map((r) => {
                return included.find((e) => e.type === r.type && e.id === r.id);
            })
                .filter((i) => !!i);
        }
        const relationItem = entityRelation.data;
        return included.find((e) => {
            return e.type === relationItem.type && e.id === relationItem.id;
        });
    }
    transformRelationInclude({ include, transform }) {
        const relationAttributes = this.transformAttributes({
            attributes: include.attributes,
            transform,
        });
        return {
            id: include.id,
            ...relationAttributes,
        };
    }
    transformApiEntityRelation({ relation, relationships, included, transform, }) {
        const entitiesIncluded = this.getApiEntityRelation({
            relation,
            relationships,
            included,
        });
        if (!entitiesIncluded) {
            return undefined;
        }
        if (Array.isArray(entitiesIncluded)) {
            return entitiesIncluded.map((entity) => this.transformRelationInclude({
                include: entity,
                transform,
            }));
        }
        return this.transformRelationInclude({
            include: entitiesIncluded,
            transform,
        });
    }
    transformApiEntityRelations({ relationships, included, transform, }) {
        if (!transform) {
            return undefined;
        }
        const data = {};
        const relKeys = Object.keys(transform);
        for (const key of relKeys) {
            if (!transform[key]) {
                continue;
            }
            if (typeof transform[key] === 'function') {
                if (!relationships) {
                    continue;
                }
                const includeRelation = this.getApiEntityRelation({
                    relation: key,
                    relationships,
                    included,
                });
                if (!includeRelation) {
                    continue;
                }
                data[key] = transform[key]({
                    relation: relationships[key],
                    entity: includeRelation,
                });
            }
            else {
                data[key] = this.transformApiEntityRelation({
                    relation: key,
                    relationships,
                    included,
                    transform: transform[key],
                });
            }
        }
        return data;
    }
}
exports.TransformApiResponse = TransformApiResponse;
